import { render, staticRenderFns } from "./Skin.vue?vue&type=template&id=ef09ea20&scoped=true"
import script from "./Skin.vue?vue&type=script&lang=js"
export * from "./Skin.vue?vue&type=script&lang=js"
import style0 from "./Skin.vue?vue&type=style&index=0&id=ef09ea20&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef09ea20",
  null
  
)

export default component.exports